export default __webpack_public_path__ + "static/media/Mosaic2-min.b13ad1ea.jpg";